export enum HuntingAttributeAlertLevel {
  none = 'none',
  normal = 'normal',
  warning = 'warning',
  critical = 'critical',
}
